<template>
  <div class="bg">
    <div class="btn">
      <div @click="turn" class="go"></div>
    </div>
  </div>
</template>

<script>
import preloadService from '../services/preloadService';

export default {
  name: 'HomePage',
  data() {
    return {
      title: '',
      message: '这是一个标准的Vue 2模板页面'
    }
  },
  methods: {
    turn(){
      this.$router.push({ path: '/view' });
    },
    handleClick() {
      alert('按钮被点击了！');
    }
  },
  mounted() {
    // 开始预加载全景图
    preloadService.preloadAllPanoramas();
  }
}
</script>

<style scoped>
.bg{
  background-image: url('https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/cover.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  width: 100vw;
  height: 100vh;
  position: relative;
  
}

.bg .btn{ 
  position: fixed;
  top: 55.8vh;
  display: flex;
  justify-content: center;
  width: 100vw;
}

.go{
  width: 200px;
  height: 55px;
  background-image: url('https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/enter.png');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
}

.go:hover {
  transform: scale(1.05);
  filter: brightness(1.1);
}

.go:active {
  transform: scale(1.02);
  filter: brightness(0.95);
}
</style>